<template>
  <div>
    <checkbox :is-selected="form.agreeTo" @onClick="toggleAgreements">
      <template v-slot:label>
        <span class="car-text">
          <span data-js="agreement-text">{{ $t('appointmentSelectionPage.agreeTo') }}</span>
          <span id="show-modal" v-for="agreement in agreements" v-bind:key="agreement.id" @click="agreement.showModal = true">
            <a class="car-link">{{ agreement.title }}</a>
            <span v-if="agreement.indexOfAgreement !== agreements.length - 1"> {{ $t('appointmentSelectionPage.and') }} </span>
          </span>
        </span>
        <div v-bind:key="agreement.id" v-for="agreement in agreements">
          <modal @close="agreement.showModal = false" v-if="agreement.showModal">
            <div slot="body" v-html="agreement.textHtml"></div>
          </modal>
        </div>
      </template>
    </checkbox>
    <div class="car-error-message" v-if="!v.form.agreeTo.validAgreements && v.form.agreeTo.$error">
      {{$t('appointmentSelectionPage.errors.agreeTo')}}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal';
import showdown from 'showdown';
import Checkbox from '@/components/Checkbox';

export default {
  name: 'Agreements',
  props: {
    form: {
      default: {}
    },
    v: {
      default: {}
    }
  },
  computed: {
    ...mapGetters('serviceCase', {
      agreements: 'agreements'
    })
  },
  methods: {
    toggleAgreements: function() {
      this.form.agreeTo = !this.form.agreeTo;
    }
  },
  created() {
    const converter = new showdown.Converter();
    this.agreements.forEach((agreement, index) => {
      this.$set(agreement, 'textHtml', converter.makeHtml(agreement.text));
      this.$set(agreement, 'showModal', false);
      this.$set(agreement, 'indexOfAgreement', index);
    });
  },
  components: {
    Checkbox,
    Modal
  }
};
</script>
